import {
  FETCH_UNPAID_TICKETS,
  FETCH_UNPAID_TICKETS_SUCCESS,
  FETCH_UNPAID_TICKETS_FAILURE,
} from './actions';
import { TICKETS } from './type';

export const INITIAL_STATE: TICKETS.TicketReducer = {
  isLoading: 0,
  error: {},
  unpaidTickets: [],
};

const ticketReducer = (
  action: IAction,
  state = INITIAL_STATE
): TICKETS.TicketReducer => {
  switch (action.type) {
    case FETCH_UNPAID_TICKETS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case FETCH_UNPAID_TICKETS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        unpaidTickets: action.payload,
        error: {},
      };
    case FETCH_UNPAID_TICKETS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        unpaidTickets: [],
        error: { fetchUnpaidTickets: action.payload.message },
      };
    default:
      return state;
  }
};

export default ticketReducer;
